import { default as _5_45month_45cart_45offerdZ4UOAeyODMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/5-month-cart-offer.vue?macro=true";
import { default as _6_45month_45half_45priceBJ8SbPwTZQMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/6-month-half-price.vue?macro=true";
import { default as abouttfiFZ6OEOJMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/about.vue?macro=true";
import { default as billingyBYCw6qTEyMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/account/billing.vue?macro=true";
import { default as emptyservicesvbxg1be7uTMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/account/emptyservices.vue?macro=true";
import { default as indexWZuNlPX9YxMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/account/index.vue?macro=true";
import { default as profilenIdL7R0H3NMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/account/profile.vue?macro=true";
import { default as ServiceOffersanGMPWNGJsMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/account/ServiceOffers.vue?macro=true";
import { default as account8kP9Ql8HnGMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/account.vue?macro=true";
import { default as authorizeoreo02i0t9Meta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/authorize.vue?macro=true";
import { default as bbc_45promoocL8oYqzL0Meta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/bbc-promo.vue?macro=true";
import { default as broadband_45friends_45and_45familyrU59z5XwrVMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/broadband-friends-and-family.vue?macro=true";
import { default as bundleszsbk0Dx6yAMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/bundles.vue?macro=true";
import { default as chatbhZum3in6hMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/chat.vue?macro=true";
import { default as childfundOp4jnXLMfiMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/childfund.vue?macro=true";
import { default as compass_45embedWRWt95vestMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/compass-embed.vue?macro=true";
import { default as compass7rHTNrk9YXMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/compass.vue?macro=true";
import { default as contactKuJiEhM5oRMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/contact.vue?macro=true";
import { default as coverage6CfahPzb6KMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/coverage.vue?macro=true";
import { default as easter_45promo5mAEkoTII5Meta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/easter-promo.vue?macro=true";
import { default as friends_45and_45family_45join_45nowVfrsaku3H7Meta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/friends-and-family-join-now.vue?macro=true";
import { default as glimp_45mobilenkA3dnk6IZMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/glimp-mobile.vue?macro=true";
import { default as glimpJ4lSb8HBcjMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/glimp.vue?macro=true";
import { default as hyperfibremC0YGP6gV0Meta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/hyperfibre.vue?macro=true";
import { default as index6mMoEPaZHkMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/index.vue?macro=true";
import { default as internet_45speed_45testuICgfwSTeJMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/internet-speed-test.vue?macro=true";
import { default as join_45nowbsYftylfaeMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/join-now.vue?macro=true";
import { default as loginwpre7TPuO8Meta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/login.vue?macro=true";
import { default as logoutJUxRJycCZiMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/logout.vue?macro=true";
import { default as mobile_45compare1q0UvE5i1BMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-compare.vue?macro=true";
import { default as mobile_45dealz1qTVrR34EMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-deal.vue?macro=true";
import { default as mobile_45easter_45promos1ys3Z4yELMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-easter-promo.vue?macro=true";
import { default as mobile_45friends_45and_45family2a6MaNrJoKMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-friends-and-family.vue?macro=true";
import { default as index0nEbBjRV6qMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/index.vue?macro=true";
import { default as account3ka9urh0FNMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/account.vue?macro=true";
import { default as connection_45setup2BIfhp4jQhMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/connection-setup.vue?macro=true";
import { default as indexqC295bm1fUMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/index.vue?macro=true";
import { default as order_45summaryrZ9Jnp8KfiMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/order-summary.vue?macro=true";
import { default as select_45planMByp49pg8SMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/select-plan.vue?macro=true";
import { default as successEBa5S95RbOMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/success.vue?macro=true";
import { default as registerK2Mm3wrESRMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register.vue?macro=true";
import { default as planspcneiDXGOEMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/plans.vue?macro=true";
import { default as privacyfF9qIKLY1mMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/privacy.vue?macro=true";
import { default as promotions01h9LWRYegMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/promotions.vue?macro=true";
import { default as refer_45a_45friendiqSDsn5RJiMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/refer-a-friend.vue?macro=true";
import { default as _1uRjgl6mHLyMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register/1.vue?macro=true";
import { default as _2VmcMjw8ZZIMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register/2.vue?macro=true";
import { default as _3Ff5RI24bmKMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register/3.vue?macro=true";
import { default as _4qxFgOrr9aJMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register/4.vue?macro=true";
import { default as _5gX5kKR82KLMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register/5.vue?macro=true";
import { default as index0lU3eHTrydMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register/index.vue?macro=true";
import { default as success07n2i8C3rtMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register/success.vue?macro=true";
import { default as register245PbJt5DoMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/register.vue?macro=true";
import { default as simply_45broadbandzK1ihsGKvSMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/simply-broadband.vue?macro=true";
import { default as sustainabilityfr2NyL0XuQMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/sustainability.vue?macro=true";
import { default as termsnLRf42QQKmMeta } from "/codebuild/output/src4161878446/src/zeronet-web/pages/terms.vue?macro=true";
export default [
  {
    name: "5-month-cart-offer",
    path: "/5-month-cart-offer",
    meta: _5_45month_45cart_45offerdZ4UOAeyODMeta || {},
    redirect: "/",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/5-month-cart-offer.vue")
  },
  {
    name: "6-month-half-price",
    path: "/6-month-half-price",
    meta: _6_45month_45half_45priceBJ8SbPwTZQMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/6-month-half-price.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: abouttfiFZ6OEOJMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/about.vue")
  },
  {
    name: account8kP9Ql8HnGMeta?.name,
    path: "/account",
    meta: account8kP9Ql8HnGMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/account.vue"),
    children: [
  {
    name: "account-billing",
    path: "billing",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/account/billing.vue")
  },
  {
    name: "account-emptyservices",
    path: "emptyservices",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/account/emptyservices.vue")
  },
  {
    name: "account",
    path: "",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/account/index.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/account/profile.vue")
  },
  {
    name: "account-ServiceOffers",
    path: "ServiceOffers",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/account/ServiceOffers.vue")
  }
]
  },
  {
    name: "authorize",
    path: "/authorize",
    meta: authorizeoreo02i0t9Meta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/authorize.vue")
  },
  {
    name: "bbc-promo",
    path: "/bbc-promo",
    meta: bbc_45promoocL8oYqzL0Meta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/bbc-promo.vue")
  },
  {
    name: "broadband-friends-and-family",
    path: "/broadband-friends-and-family",
    meta: broadband_45friends_45and_45familyrU59z5XwrVMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/broadband-friends-and-family.vue")
  },
  {
    name: "bundles",
    path: "/bundles",
    meta: bundleszsbk0Dx6yAMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/bundles.vue")
  },
  {
    name: "chat",
    path: "/chat",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/chat.vue")
  },
  {
    name: "childfund",
    path: "/childfund",
    meta: childfundOp4jnXLMfiMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/childfund.vue")
  },
  {
    name: "compass-embed",
    path: "/compass-embed",
    meta: compass_45embedWRWt95vestMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/compass-embed.vue")
  },
  {
    name: "compass",
    path: "/compass",
    meta: compass7rHTNrk9YXMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/compass.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactKuJiEhM5oRMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/contact.vue")
  },
  {
    name: "coverage",
    path: "/coverage",
    meta: coverage6CfahPzb6KMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/coverage.vue")
  },
  {
    name: "easter-promo",
    path: "/easter-promo",
    meta: easter_45promo5mAEkoTII5Meta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/easter-promo.vue")
  },
  {
    name: "friends-and-family-join-now",
    path: "/friends-and-family-join-now",
    meta: friends_45and_45family_45join_45nowVfrsaku3H7Meta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/friends-and-family-join-now.vue")
  },
  {
    name: "glimp-mobile",
    path: "/glimp-mobile",
    meta: glimp_45mobilenkA3dnk6IZMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/glimp-mobile.vue")
  },
  {
    name: "glimp",
    path: "/glimp",
    meta: glimpJ4lSb8HBcjMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/glimp.vue")
  },
  {
    name: "hyperfibre",
    path: "/hyperfibre",
    meta: hyperfibremC0YGP6gV0Meta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/hyperfibre.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index6mMoEPaZHkMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/index.vue")
  },
  {
    name: "internet-speed-test",
    path: "/internet-speed-test",
    meta: internet_45speed_45testuICgfwSTeJMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/internet-speed-test.vue")
  },
  {
    name: "join-now",
    path: "/join-now",
    meta: join_45nowbsYftylfaeMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/join-now.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginwpre7TPuO8Meta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutJUxRJycCZiMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/logout.vue")
  },
  {
    name: "mobile-compare",
    path: "/mobile-compare",
    meta: mobile_45compare1q0UvE5i1BMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-compare.vue")
  },
  {
    name: "mobile-deal",
    path: "/mobile-deal",
    meta: mobile_45dealz1qTVrR34EMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-deal.vue")
  },
  {
    name: "mobile-easter-promo",
    path: "/mobile-easter-promo",
    meta: mobile_45easter_45promos1ys3Z4yELMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-easter-promo.vue")
  },
  {
    name: "mobile-friends-and-family",
    path: "/mobile-friends-and-family",
    meta: mobile_45friends_45and_45family2a6MaNrJoKMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile-friends-and-family.vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    meta: index0nEbBjRV6qMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/index.vue")
  },
  {
    name: registerK2Mm3wrESRMeta?.name,
    path: "/mobile/register",
    meta: registerK2Mm3wrESRMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register.vue"),
    children: [
  {
    name: "mobile-register-account",
    path: "account",
    meta: account3ka9urh0FNMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/account.vue")
  },
  {
    name: "mobile-register-connection-setup",
    path: "connection-setup",
    meta: connection_45setup2BIfhp4jQhMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/connection-setup.vue")
  },
  {
    name: "mobile-register",
    path: "",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/index.vue")
  },
  {
    name: "mobile-register-order-summary",
    path: "order-summary",
    meta: order_45summaryrZ9Jnp8KfiMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/order-summary.vue")
  },
  {
    name: "mobile-register-select-plan",
    path: "select-plan",
    meta: select_45planMByp49pg8SMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/select-plan.vue")
  },
  {
    name: "mobile-register-success",
    path: "success",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/mobile/register/success.vue")
  }
]
  },
  {
    name: "plans",
    path: "/plans",
    meta: planspcneiDXGOEMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/plans.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyfF9qIKLY1mMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/privacy.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    meta: promotions01h9LWRYegMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/promotions.vue")
  },
  {
    name: "refer-a-friend",
    path: "/refer-a-friend",
    meta: refer_45a_45friendiqSDsn5RJiMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/refer-a-friend.vue")
  },
  {
    name: register245PbJt5DoMeta?.name,
    path: "/register",
    meta: register245PbJt5DoMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register.vue"),
    children: [
  {
    name: "register-1",
    path: "1",
    meta: _1uRjgl6mHLyMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register/1.vue")
  },
  {
    name: "register-2",
    path: "2",
    meta: _2VmcMjw8ZZIMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register/2.vue")
  },
  {
    name: "register-3",
    path: "3",
    meta: _3Ff5RI24bmKMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register/3.vue")
  },
  {
    name: "register-4",
    path: "4",
    meta: _4qxFgOrr9aJMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register/4.vue")
  },
  {
    name: "register-5",
    path: "5",
    meta: _5gX5kKR82KLMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register/5.vue")
  },
  {
    name: "register",
    path: "",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register/index.vue")
  },
  {
    name: "register-success",
    path: "success",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/register/success.vue")
  }
]
  },
  {
    name: "simply-broadband",
    path: "/simply-broadband",
    meta: simply_45broadbandzK1ihsGKvSMeta || {},
    redirect: "/",
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/simply-broadband.vue")
  },
  {
    name: "sustainability",
    path: "/sustainability",
    meta: sustainabilityfr2NyL0XuQMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/sustainability.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsnLRf42QQKmMeta || {},
    component: () => import("/codebuild/output/src4161878446/src/zeronet-web/pages/terms.vue")
  }
]